import { OTHER_NAME_REGEX } from "../helper/string";

export const AddRoleConfig = {
  showLabel: true,
  formKey: "add",
  submitBtnText: "Add",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Role name",
          field: "roleName",
          apiField: "roleName",
          placeholder: "Enter role name",
          validation: {
            required: true,
            maxLength: 100,
            pattern: {
              value: OTHER_NAME_REGEX,
              message: "Enter a valid role name.",
            },
          },
        },
        {
          widgetType: "select-from-api",
          placeholder: "Select",
          label: "Select role to clone",
          field: "cloneFrom",
          apiField: "cloneFrom",
          validation: {
            required: true,
          },
          optionsApiUrl: "/role/options",
        },
      ],
    },
  ],
};
export const AssignRoleConfig = {
  showLabel: true,
  formKey: "add",
  submitBtnText: "Assign",
  sections: [
    {
      widgets: [
        {
          widgetType: "select-from-api",
          label: "Select Employee",
          field: "empId",
          isAddEmpIDFilter: true,
          validation: {
            required: true,
          },
          apiField: "reportingMngr",
          optionsApiUrl: "/employee/option?option_key=employees&filter=active",
          showSearch: true,
        },
      ],
    },
  ],
};

export const EditRoleConfig = {
  showLabel: true,
  formKey: "edit",
  submitBtnText: "Save",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Role name",
          field: "roleName",
          apiField: "roleName",
          validation: {
            required: true,
            maxLength: 100,
            pattern: {
              value: OTHER_NAME_REGEX,
              message: "Enter a valid role name.",
            },
          },
        },
      ],
    },
  ],
};
